import { Component, OnInit } from "@angular/core";
import { ReportConfigService } from "./report-config.service";
import { ReportConfig } from "./report-config.model";
import { ReportConfigViewComponent } from "./report-config-view/report-config-view.component";
import { PaginationColumn } from "../../_component/pagination-client-side/pagination-column.class";
import { RowsLoaderService } from "../../../_services/rows-loader.service";
import { TranslateService } from "@ngx-translate/core";
import { DictionaryService } from "../../../dictionary/dictionary.service";
import { HeaderModel } from "src/app/_component/header/header.model";
import { ThisPlatform } from "src/app/_services/platform.service";
import { HeaderService } from "src/app/_services/header.service";

@Component({
  selector: "app-report-config",
  templateUrl: "./report-config.page.html",
  styleUrls: ["./report-config.page.scss"],
})
export class ReportConfigPage {
  constructor(
    public reportConfigServ: ReportConfigService,
    private translateService: TranslateService,
    private dictionaryService: DictionaryService,
    public p: ThisPlatform,
    private headerServ: HeaderService,
  ) {}

  headerInit: HeaderModel = {
    title: "REPORT_CONFIG.REPORTS_CONFIG",
    backDefaultHref: "/app/report",
  };

  componentRef: any = ReportConfigViewComponent;
  columnsDefinition: PaginationColumn[] = [
    {
      name: "name",
      displayName: "REPORT_CONFIG.NAME",
      size: 2,
      sortable: true,
    },
    {
      name: "system",
      displayName: "REPORT_CONFIG.SYSTEM",
      size: 2,
      sortable: true,
      colValue: (row) => {
        return this.dictionaryService.systemName(row.system);
      },
    },
    {
      name: "sendEmail",
      displayName: "REPORT_CONFIG.SEND_EMAIL",
      size: 2,
      sortable: true,
      center: true,
    },
    {
      name: "sendSms",
      displayName: "REPORT_CONFIG.SEND_SMS",
      size: 2,
      sortable: true,
      center: true,
    },
    {
      name: "sendNotification",
      displayName: "REPORT_CONFIG.SEND_NOTIFICATION",
      size: 2,
      sortable: true,
      center: true,
    },
    {
      name: "autoGenReportTask",
      displayName: "REPORT_CONFIG.AUTO_GENERATE_TASK",
      size: 2,
      sortable: true,
      center: true,
    },
  ];

  rowsLoader: RowsLoaderService;
  
  ionViewWillEnter() {
    this.headerServ.setHeaderInit(this.headerInit);
    this.refreshReportConfigs();
  }

  rowsLoaderInit() {
    if (this.rowsLoader) {
      this.rowsLoader.init(this.reportConfigServ.reportConfigs);
    }
  }

  refreshReportConfigs() {
    this.reportConfigServ
      .getReportConfigurations()
      .subscribe((reportConfig: ReportConfig[]) => {
        this.reportConfigServ.reportConfigs = reportConfig;
        this.rowsLoaderInit();
      });
  }

  rowsLoaderServiceReady(loader: RowsLoaderService) {
    this.rowsLoader = loader;
  }
}
